<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="box box-danger box-solid">
      <div class="box-header with-border">
        <h3 class="box-title"><i class="fa fa-exclamation-triangle mr-5"></i>{{'label_errors' | translate}}</h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
          </button>
          <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
        </div>
      </div>
      <div class="box-body">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>Information</th>
              <th>Status</th>
              <th class="text-center">Retry</th>
              <th class="text-center">Delete</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="errorLabel in labelErrors">
              <td>
                <div v-for="message in getMessages(errorLabel)" @click="$emit('payload')" class="alert alert-danger" style="margin-bottom: 5px !important">
                  <span><i class="fa fa-exclamation-triangle mr-5"></i>{{message}}</span>
                </div>
              </td>
              <td>{{errorLabel.status}}</td>
              <td class="text-center"><button class="btn btn-sm btn-info no-margin" @click="$emit('retry', errorLabel.id)"><i class="fa fa-refresh"></i></button></td>
              <td class="text-center"><button class="btn btn-sm btn-info no-margin" @click="$emit('deleteLabel', errorLabel.id)"><i class="fa fa-trash"></i></button></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="box-footer"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['labelErrors'],
    name: "LabelErrorsModule",
    data () {
      return {

      }
    },
    methods: {
      getMessages (label) {
        let messagesArr = []
        if (label.message.substr(0,1) === '{') {
          let messages = JSON.parse(label.message)
          if(messages.hasOwnProperty('errors')) {
            for (let x in messages.errors) {
              messagesArr.push(messages.errors[x])
            }
          }else{
            messagesArr.push(label.message)
          }
        } else {
          messagesArr.push(label.message)
        }
        return messagesArr
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/LabelErrorsModule.vue